import { object, string } from 'yup'

import { TipoArticuloInputProps } from '../interfaces'

export const tipoArticuloActualizarValidator = async (
  input: TipoArticuloInputProps,
): Promise<Array<string>> => {
  try {
    const schema = {
      codigo: string().required('Ingrese el Código Tipo Artículo'),
      descripcion: string().required('Ingrese la Descripción'),
      // grupoUnidadMedida: string().required(),
    }
    return []
  } catch (e: any) {
    return [e.message]
  }
}

export const TipoArticuloActualizarValidationSchema = object({
  codigo: string().required('Ingrese el Código Tipo Artículo'),
  descripcion: string().required('Ingrese la Descripción'),
})
